import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-exclamation-circle-light",
  "use": "foquz-icon-exclamation-circle-light-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-exclamation-circle-light\"><path clip-rule=\"evenodd\" d=\"M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12z\" stroke=\"#F96261\" stroke-width=\"2\" /><path d=\"M12 8a1 1 0 112 0v6a1 1 0 11-2 0V8zm0 10a1 1 0 112 0 1 1 0 01-2 0z\" fill=\"#F96261\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol